import { getApiUrl, API_BASE_URLS } from "../config/api.config";

const BASE_PATH = "/Orders";
const getBackendUrl = () => {
  const baseUrl = API_BASE_URLS.backend || "";
  return baseUrl.replace(/\/$/, "");
};
const buildUsersUrl = (path = "") => {
  return `${getBackendUrl()}${BASE_PATH}${path}`;
};

export const USERS_ENDPOINTS = {
  GET_CURRENT: buildUsersUrl("/me"),
  UPDATE_CURRENT: buildUsersUrl("/me"),
  GET_BY_ID: (userId) => buildUsersUrl(`/${userId}`),
  GET_ALL: buildUsersUrl(),
  SEARCH: buildUsersUrl("/search"),
  // GET_NOTIFICATIONS: (email) =>
  //   buildUsersUrl(`/notifications/${encodeURIComponent(email)}`),
  GET_NOTIFICATIONS: (email, role, roleId, days = 14) =>
    buildUsersUrl(
      `/notifications/${encodeURIComponent(email)}/${encodeURIComponent(role)}/${encodeURIComponent(roleId)}`,
    ),
  MARK_NOTIFICATIONS_READ: (id) => buildUsersUrl(`/notifications/${id}/read`),
  MARK_NOTIFICATION_ACTION_TAKEN: buildUsersUrl(
    "/mark-notification-action-taken",
  ),
};

// User Management endpoints
const USER_MANAGEMENT_BASE_PATH = "/UserManagement";
const buildUserManagementUrl = (path = "") => {
  return `${getBackendUrl()}${USER_MANAGEMENT_BASE_PATH}${path}`;
};

export const USER_MANAGEMENT_ENDPOINTS = {
  GET_ALL_USERS: buildUserManagementUrl("/listing"),
  CREATE_USER: buildUserManagementUrl("/AddUser"),
  GET_USER_ROLES: (userId) => buildUserManagementUrl(`/GetRoles/${userId}`),
};

export const MS_GRAPH_ENDPOINTS = {
  GET_ME: `${API_BASE_URLS.msGraph}/me`,
  GET_MY_PHOTO: `${API_BASE_URLS.msGraph}/me/photo/$value`,
  GET_USER_PHOTO: (userId) =>
    `${API_BASE_URLS.msGraph}/users/${userId}/photo/$value`,
  GET_USER: (userId) => `${API_BASE_URLS.msGraph}/users/${userId}`,
  SEARCH_USERS: `${API_BASE_URLS.msGraph}/users`,
  GET_DIRECT_REPORTS: `${API_BASE_URLS.msGraph}/me/directReports`,
  GET_MANAGER: `${API_BASE_URLS.msGraph}/me/manager`,
};

export default {
  USERS_ENDPOINTS,
  MS_GRAPH_ENDPOINTS,
  USER_MANAGEMENT_ENDPOINTS,
};
